<template>
  <div class="comunication-list_container width-responsiveness">
    <md-dialog
      id="modDashboardComponents"
      ref="editComunication"
      md-title
      :md-esc-to-close="false"
      :md-click-outside-to-close="false"
      class="edit-alert-modal"
    >
      <md-dialog-title>
        <span>Editar Aviso</span>
        <button
          id="mod_btnClose"
          class="close-button btn-transparent"
          @click="closeEditAlert"
        >
          <md-icon>clear</md-icon>
        </button>
      </md-dialog-title>
      <md-dialog-content>
        <comunication-edit
          :alert-for-edition="alertForEdition"
          :is-modal-open="isModalOpen"
          :close-edit-alert="closeEditAlert"
        />
      </md-dialog-content>
    </md-dialog>

    <table class="apoio-datatable apoio-datable-margin white-head">
      <colgroup>
        <col class="column-id-notification" />
        <col class="column-title" />
        <col class="column-message" />
        <col class="column-link" />
        <col class="column-date-notification" />
        <col class="column-date-notification" />
        <col class="column-status-notification" />
        <col class="column-type-notification" />
        <col class="column-send-notification" />
        <col class="column-edit-notification" />
      </colgroup>
      <thead>
        <tr class="apoio-datatable__header-line">
          <th
            title="ID"
            class="column-id-notification"
          >
            ID
          </th>
          <th
            title="TITULO DO AVISO"
            class="column-title"
          >
            TITULO
          </th>
          <th
            title="CONTEÚDO DO AVISO"
            class="column-message"
          >
            MENSAGEM
          </th>
          <th
            title="LINK DO AVISO"
            class="column-link"
          >
            LINK
          </th>
          <th
            title="DATA INICIAL"
            class="column-date-notification"
          >
            DATA INICIAL
          </th>
          <th
            title="DATA FINAL"
            class="column-date-notification"
          >
            DATA FINAL
          </th>
          <th
            title="STATUS"
            class="column-status-notification"
          >
            STATUS
          </th>
          <th
            title="STATUS"
            class="column-type-notification"
          >
            TIPO
          </th>
          <th class="column-send-notification">ENVIADO PARA:</th>
          <th class="column-edit-notification" />
        </tr>
      </thead>
    </table>

    <table
      ref="tableNotifies"
      class="apoio-datatable apoio-datatable-alt apoio-datable-margin-notification"
    >
      <colgroup>
        <col class="column-id-notification" />
        <col class="column-title" />
        <col class="column-message" />
        <col class="column-link" />
        <col class="column-date-notification" />
        <col class="column-date-notification" />
        <col class="column-status-notification" />
        <col class="column-type-notification" />
        <col class="column-send-notification" />
        <col class="column-edit-notification" />
      </colgroup>

      <tbody>
        <tr
          v-for="(notification, rowIndex) in notifications"
          :key="rowIndex"
        >
          <td class="column-id-notification">
            {{ notification['id-notification'] }}
          </td>
          <td class="column-title">
            <span :title="notification.title">{{ notification.title }}</span>
          </td>
          <td class="column-message">
            <span :title="notification.message">{{ notification.message }}</span>
          </td>
          <td class="column-link">
            <span
              v-if="notification.link"
              :title="notification.link"
            >
              {{ notification.link }}
            </span>
            <span
              v-else
              title="Essa notificação não possui link."
            >
              -
            </span>
          </td>
          <td class="column-date-notification">
            {{ reformatDate(notification['start-date']) }}
          </td>
          <td class="column-date-notification">
            {{ reformatDate(notification['end-date']) }}
          </td>
          <td class="column-status-notification">
            <center>{{ $strings.alertsStates[notification.enabled].text }}</center>
          </td>
          <td class="column-type-notification">
            <span v-if="notification.type && getType(notification.type)">
              <md-icon
                :title="getType(notification.type).label"
                :md-src="
                  '/static/images/icon-notification-' +
                  getType(notification.type).icon +
                  '.svg'
                "
              />
              <md-tooltip md-direction="top">
                {{ getType(notification.type).label }}
              </md-tooltip>
            </span>
            <span v-else>{{ notification.type || 'Sem Tipo' }}</span>
          </td>
          <td class="column-send-notification">
            <span v-if="notification.sendAll">
              Todos
              <md-tooltip md-direction="top">Enviado a todos os laboratórios</md-tooltip>
            </span>
            <span
              v-else
              class="info"
            >
              Personalizado
              <md-icon>info</md-icon>
              <md-tooltip
                md-direction="top"
                class="comunication-custom-tooltip"
              >
                <h4>ID dos Laboratórios:</h4>
                <p>
                  <span
                    v-for="(labId, index) in notification.ids"
                    :key="index"
                  >
                    {{ labId }}
                    <span v-if="index + 1 < notification.ids.length">,</span>
                  </span>
                </p>
              </md-tooltip>
            </span>
          </td>
          <td class="column-edit-notification">
            <div
              :id="'alert-actions-' + notification['id-notification']"
              class="alert-actions"
            >
              <div
                class="status-icon icon-edit-alt"
                @click="openEditAlert(notification)"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Editar
                </md-tooltip>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="notifications.length > 0 && alertLoadingStatus !== 'STATUS_END'">
        <tr>
          <td colspan="10">
            <infinite-loading
              ref="infiniteLoading"
              @infinite="onInfinite"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
      </tfoot>
    </table>

    <div
      v-if="alertLoadingStatus === 'STATUS_LOADING' && notifications.length === 0"
      class="loading-search"
    >
      <spinner />
    </div>

    <div
      v-if="alertLoadingStatus === 'STATUS_END' && notifications.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não encontramos nenhuma notificação.</p>
    </div>

    <div
      v-if="alertLoadingStatus === 'STATUS_FAILED' && notifications.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não foi possível buscar as notificações. Tente novamente.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/common/Spinner'
import ComunicationEdit from './ComunicationEdit'
import strings from '@/strings'

export default {
  name: 'ComunicationList',
  components: {
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    'comunication-edit': ComunicationEdit,
  },
  data: () => {
    return {
      alertForEdition: null,
      isModalOpen: false,
      alertForExclusion: '',
    }
  },
  computed: {
    ...mapGetters(['notifications', 'alertLoadingStatus']),
  },
  async mounted() {
    await this.resetNotificationPagination()
    await this.getServiceAlert()
  },
  methods: {
    ...mapActions([
      'getServiceAlert',
      'clearAllAlertData',
      'resetNotificationPagination',
    ]),
    async onInfinite($state) {
      try {
        await this.getServiceAlert()

        if (this.alertLoadingStatus === 'STATUS_END') {
          $state.complete()
        } else if (this.alertLoadingStatus === 'STATUS_LOADED') {
          $state.loaded()
        } else if (this.alertLoadingStatus === 'STATUS_FAILED') {
          $state.error()
        }
      } catch (error) {
        console.error('Erro ao carregar notificações:', error)
        $state.error()
      }
    },
    reformatDate(date) {
      let dateCutted = date.slice(0, 10)
      return dateCutted.split('-').reverse().join('-')
    },
    closeEditAlert() {
      this.$refs.editComunication.close()
      this.isModalOpen = false
      setTimeout(() => {
        this.reload()
      }, 300)
    },
    openEditAlert(alert) {
      this.alertForEdition = alert
      this.$refs.editComunication.open()
      this.isModalOpen = true
    },
    getType: function (type) {
      const notificationType = strings.notificationTypes.filter(
        options => options.value === type
      )[0]
      return (
        notificationType || { label: 'Tipo desconhecido', icon: 'default', value: type }
      )
    },
    reload() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../static/stylesheets/mixins';

.edit-alert-modal {
  width: 100% !important;
  min-width: 500px !important;

  .md-dialog {
    min-width: 95% !important;
    width: 100% !important;
    height: 100% important;
  }
}

.apoio-datatable-alt {
  tr {
    height: 55px;
  }

  tr:hover td {
    background-color: #ebebeb;
  }

  tr:hover {
    border-radius: 90px;
    box-sizing: border-box;
  }

  tr:hover td .alert-actions {
    display: block;
  }

  tr:not(:hover) td .alert-actions {
    display: none;
  }

  td {
    font-size: 13px;
  }
}

.apoio-datable-margin {
  margin: 0px !important;
}

.apoio-datable-margin-notification {
  margin-top: 0px !important;
  margin-bottom: 60px !important;
}

.apoio-datatable {
  position: relative;

  &__line {
    height: 56px;
  }

  &.white-head {
    &::after {
      width: 96%;
      z-index: 1;
    }
  }
}

.status-container {
  display: flex;
  justify-content: left;
  margin-left: 1.1em;

  .status-icon {
    margin: 0 5px;
  }

  .status-symbol {
    font-family: Roboto, sans-serif;
    font-size: 20px;
    letter-spacing: 1.33px;
    text-transform: uppercase;
    font-weight: 900;
    margin-right: 8.5px;
  }

  .status-text {
    font-family: Roboto, sans-serif;
    font-size: 10px;
    letter-spacing: 1.33px;
    text-transform: uppercase;
    font-weight: 900;
  }
}

.comunication-list_container {
  width: 100%;
  margin: 0;
  padding: 0;

  .column-id-notification {
    width: 5%;
    text-align: center;
  }

  .column-date-notification {
    width: 12%;
    text-align: center;
  }

  .column-title {
    width: 10%;
    text-align: center;
  }

  .column-message {
    width: 15%;
    text-align: center;
  }

  .column-link {
    width: 10%;
  }

  .column-status-notification {
    width: 10%;
    text-align: center;
  }

  .column-type-notification {
    width: 9%;
    text-align: center;
  }

  .column-edit-notification {
    width: 9%;
  }

  .column-send-notification {
    width: 14%;
    text-align: center;

    .info {
      cursor: help;

      .md-icon {
        color: #999;
        font-size: 19px;
        padding-left: 2px;
        margin-bottom: 2px;
      }
    }
  }
}

.notification-modal .md-dialog {
  min-width: 660px;
  min-height: 203px;
  border-radius: 7px;

  &-content {
    padding-top: 19px;
    font-size: 18px;
    letter-spacing: -0.2px;
    text-align: center;
    color: #303030;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 32px;
  }

  .dialog-actions {
    width: 100%;
    height: 44px;
    margin-top: 37px;

    .md-button {
      width: 182px;
      height: 33px;
      margin: 6px 7px;
      font-weight: 400;
      letter-spacing: 0.5px;
    }
  }
}

.alert-actions {
  display: none;
}

.comunication-custom-tooltip {
  max-width: 250px;
  width: 250px;
  height: auto;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
}

.loading-search,
.empty-search {
  width: 25%;
  position: relative;
  margin: 6% auto auto;

  .md-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 1em;
    margin-left: 40%;
  }

  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #7a7a7a;
  }
}
</style>
